/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 그리드 리스트 클래스를 정의한다.
 *
 * @file /src/components/grid/List.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 5. 19.
 */
import * as parent from '@components/grid/Grid';
import { ListStores } from '@models/store/Store';
import './List.css';

export interface Listeners<T extends List> extends parent.Listeners<T> {}

export interface Properties<T extends List> extends parent.Properties<ListStores, T> {
    /**
     * 이벤트 리스너
     */
    listeners?: Listeners<T>;
}

export class List extends parent.Grid<ListStores, List> {
    /**
     * 모드
     */
    mode = 'list';

    /**
     * 그리드 리스트 클래스를 정의한다.
     *
     * @param properties - 초기설정
     */
    constructor(public properties: Properties<List> = null) {
        super(properties);
    }
}
